import { FC, useState } from 'react';
import { ConfigsType, paymentSuccessResponseType, PlansAlgoverseProps } from './type';
import { Card } from 'react-bootstrap';
import _ from 'lodash';
import MoneyDisplay from 'common/components/MoneyDisplay';
import PlanButton from 'ui/Plans/components/common/PlanButton';
import classNames from 'classnames';
import usePlans from 'ui/Plans/usePlans';
import AlgoversePaymentModal from './AlgoversePaymentModal';

const PlansAlgoverse: FC<PlansAlgoverseProps> = ({ activePlan, activeSubscription }) => {
  const configs = usePlans({ activePlan, activeSubscription }) as unknown as ConfigsType;
  // const configs: ConfigsType = planData as unknown as ConfigsType;
  const [showModal, setShowModal] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState<paymentSuccessResponseType>({
    razorpay_order_id: '',
    status: false,
    resync_types: [],
    razorpay_payment_link: null,
    gateway_extras: {},
  });
  const [selectedPlan, setSelectedPlan] = useState<PlansAlgoverseProps['activePlan'] | null>(null);

  const {
    activePlanId,
    activePlanName,
    isSubscriptionActive,
    isCreditApplied,
    couponCode,
    isApplied,
    message,
    plansGroupedByCyclicMonths,
    onCouponUpdate,
    setCouponCode,
    appliedCouponConfig,
  } = configs;

  const handlePaymentCallBack = (
    response: paymentSuccessResponseType,
    plan: PlansAlgoverseProps['activePlan']
  ) => {
    setPaymentResponse(response);
    setSelectedPlan(plan);
    setShowModal(true);
  };

  const renderPlans = (plans: PlansAlgoverseProps['activePlan'][]): JSX.Element[] => {
    return plans.map((plan) => {
      const isBestPlan = plan.plan_name.toLowerCase().includes('advanced');

      const combinedHeaderClassName = classNames({
        'best-value': isBestPlan,
      });

      return (
        <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4" key={plan.id}>
          <Card>
            <Card.Header className={combinedHeaderClassName}>
              <h2 className="plan-name">{plan.plan_name}</h2>
            </Card.Header>

            <Card.Body>
              <div className="d-flex card-body-price">
                <MoneyDisplay isAttachCurrency>{plan.price}</MoneyDisplay>
                <span>/ month</span>
              </div>
              <div className="d-flex card-body-note">
                <span>GST applicable</span>
              </div>

              <div className="d-flex gap-5 my-3 align-items-center">
                <i className="fa-solid fa-square-check" id={`checked-input-${plan.id}`} />
                <label htmlFor={`checked-input-${plan.id}`}>{plan.historic_run_limit} Backtest credits</label>
              </div>
            </Card.Body>
            <Card.Footer>
              <PlanButton
                plan={plan}
                couponConfig={appliedCouponConfig}
                activePlanId={activePlanId}
                activePlanName={activePlanName}
                isSubscriptionActive={isSubscriptionActive}
                isCreditApplied={isCreditApplied}
                couponCode={couponCode}
                onChangeCouponCode={setCouponCode}
                isApplied={isApplied}
                onCouponUpdate={onCouponUpdate}
                message={message}
                btnClassName={combinedHeaderClassName}
                btnLabel="Buy now"
                isHideIcon
                plansGroupedByCyclicMonths={plansGroupedByCyclicMonths}
                paymentCallBack={(response: paymentSuccessResponseType) =>
                  handlePaymentCallBack(response, plan)
                }
              />
            </Card.Footer>
          </Card>
        </div>
      );
    });
  };

  return (
    <>
      <div className="plan-algoverse">
        <div className="container">
          <div className="text-center mx-auto p-4">
            <h2 className="plan-title">
              Pricing Plan For
              <span className="me-2 ms-2">Backtesting Packs</span> (Monthly).
            </h2>
          </div>

          <div className="row">
            {_.map(configs.plansGroupedByCyclicMonths, (plans) => {
              if (!plans || plans.length === 0) return null;
              return renderPlans(plans);
            })}
          </div>

          <div className="plan-description">
            <h2>Deployment charges (charged per deployment)</h2>
            <div className="row">
              <div className="col-lg-6 mb-4">
                <div className="card">
                  <div className="card__header">
                    <h3>
                      Basic deployment <strong>@ ₹10/day</strong>
                      <span> (GST applicable) </span>
                    </h3>
                    <p>For simpler strategies like straddles, strangles, or directional trades</p>
                  </div>
                  <div className="card__body">
                    <ul>
                      <li>Basic entry/exit creation</li>
                      <li>Simple option legs</li>
                      <li>No advanced adjustments</li>
                      <li>Ability to set single-day profit/loss targets</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="card">
                  <div className="card__header">
                    <h3>
                      Premium deployment <strong>@ ₹20/day</strong>
                      <span> (GST applicable) </span>
                    </h3>
                    <p>Built for advanced, multi-condition, or high-frequency strategies</p>
                  </div>
                  <div className="card__body">
                    <ul>
                      <li>Advanced adjustments</li>
                      <li>Strike multipliers</li>
                      <li>Additional cases and complex branching</li>
                      <li>Calendar spreads</li>
                      <li>Quick adjustments in option legs</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="content">
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <AlgoversePaymentModal
          showModal={showModal}
          setShowModal={setShowModal}
          orderId={paymentResponse.razorpay_order_id}
          selectedPlan={selectedPlan}
        />
      )}
    </>
  );
};

export default PlansAlgoverse;
